// src/components/constants/Layout.js

import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useNavigate } from "react-router-dom";

import { googleLogout } from '@react-oauth/google';

export const Layout = ({ Emp_Role, setsidebor }) => {
  // const { instance } = useMsal();
  const  name  = sessionStorage.getItem("UserName");
  const user_name = name.split("@")[0].toUpperCase();
  const [isSignOutVisible, setIsSignOutVisible] = useState(false);

  const toggleSignOut = () => {
    setIsSignOutVisible(!isSignOutVisible);
  };

  // const handleSignOut = () => {
  //   sessionStorage.removeItem('UserName');
  //   sessionStorage.removeItem('AdminLogin');
  //   googleLogout();
  //   navigate('/');

  // };

  const handleSignOut = () => {
    const token = localStorage.getItem("google_token");

    if (token) {
      fetch(`https://oauth2.googleapis.com/revoke?token=${token}`, {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        }
      });
    }

    localStorage.clear();
    window.location.href = "/";
  };


  return (
    <div className="flex h-screen">
      <Sidebar Emp_role={Emp_Role} setsidebor={setsidebor} />
      <main className="flex-1 py-10 px-3 relative bg-gray-100">
        <Header
          user_name={user_name}
          // initials={initials}
          toggleSignOut={toggleSignOut}
          isSignOutVisible={isSignOutVisible}
          handleSignOut={handleSignOut}
          Emp_role={Emp_Role}
        />
        <Outlet />
      </main>
    </div>
  );
};
